define( [
	"../var/pnum"
], function( pnum ) {

"use strict";

return new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/rcssNum.js
// module id = 411
// module chunks = 0